import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { AdmTableColumn } from "../../api/models/adm-table-column";
import { AdmFieldGroup } from "../../api/models/adm-field-group";
import { DialogResult, DialogResultType } from "../DialogResult";

export interface AdmColumnDialogData {
  column: AdmTableColumn;
  fieldGroups: AdmFieldGroup[];
}

// Admin ADM Definition > Tables & Columns > a physical column. Flattened columns go through
// AdmFlattenedColumnDialogComponent instead - see AdminAdmDefinitionController.SaveColumn's own note.
@Component({
  selector: "adm-column-dialog",
  templateUrl: "./adm-column-dialog.component.html",
})
export class AdmColumnDialogComponent {
  public result: AdmTableColumn;
  public Result: DialogResult = { ResultType: DialogResultType.Cancel, ResultData: null };

  constructor(public dialogRef: MatDialogRef<AdmColumnDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AdmColumnDialogData) {
    this.result = { ...data.column };
  }

  get isNew(): boolean {
    return !this.data.column.admTableColumnId;
  }

  onSave(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onToggleRetired(): void {
    this.Result.ResultType = DialogResultType.Delete;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  static showDialog(dialog: MatDialog, data: AdmColumnDialogData): Observable<DialogResult> {
    return dialog.open(AdmColumnDialogComponent, { disableClose: false, width: "800px", data }).afterClosed();
  }
}
